export interface UpdateCustomerStatusUrlParams {
  customerId: any
  statusId: number | null
  note: string
  unconfirmDate: string
  employeeId: number | null
}

/**
 * Builds the Customer/UpdateCustomerStatus request URL.
 * Mirrors the backend signature:
 * UpdateCustomerStatus(int id, short? statusId, string note = null,
 *                     DateTime? unconfirmDate = null, int? employeeId = null)
 */
export const buildUpdateCustomerStatusUrl = (
  baseUrl: string,
  { customerId, statusId, note, unconfirmDate, employeeId }: UpdateCustomerStatusUrlParams
) => {
  let apiUrl = `${baseUrl}Customer/UpdateCustomerStatus?id=${customerId}`

  if (statusId != null) {
    apiUrl += `&statusId=${statusId}&note=${note}`
  }

  if (unconfirmDate) {
    apiUrl += `&unconfirmDate=${unconfirmDate}`
  }

  if (employeeId != null) {
    apiUrl += `&employeeId=${employeeId}`
  }

  return apiUrl
}
